import { LitElement, html } from 'lit'
import { customElement, state } from 'lit/decorators.js'
import { TW } from '../../shared'

const TwLitElement = TW(LitElement)

/**
 * Simple Grid Indicator with functionality to toggle
 * 
 * @author jjarolim
 */
@customElement('grid-indicator')
export class GridIndicator extends TwLitElement {

    @state()
    private _show: boolean = true

    private _gridContainer: HTMLDivElement | null = null

    /**
     * Key used to persist the visibility state in localStorage
     */
    private readonly _storageKey = 'grid-indicator-show'

    private _toggleGridContainer( override: boolean | null = null ) {

        // Wenn ein Override übergeben wird, diesen Wert verwenden,
        // ansonsten den aktuellen Zustand toggeln
        const nextShowState = override !== null ? override : ! this._show

        this._show = nextShowState

        // State in localStorage persistieren
        try {
            window.localStorage.setItem(this._storageKey, String(this._show))
        } catch (e) {
            // Ignorieren, falls localStorage nicht verfügbar ist
        }

        // Falls der Grid-Container bereits existiert, Anzeige anpassen
        if ( this._gridContainer ) {
            this._gridContainer.style.display = nextShowState ? 'grid' : 'none'
        }
    }

    connectedCallback() {
        super.connectedCallback()

        // Den Grid-Container bauen

        this._gridContainer = document.createElement('div')
        this._gridContainer.style.position = 'fixed'
        this._gridContainer.style.top = '0'
        this._gridContainer.style.bottom = '0'
        this._gridContainer.style.left = '0'
        this._gridContainer.style.right = '0'
        this._gridContainer.style.opacity = '0.1'
        this._gridContainer.style.zIndex = '-10'
        this._gridContainer.classList.add('container')
        this._gridContainer.id = 'grid-indicator'

        // Persistierten State aus localStorage lesen
        try {
            const stored = window.localStorage.getItem(this._storageKey)
            if ( stored !== null ) {
                this._show = stored === 'true'
            }
        } catch (e) {
            // Ignorieren, falls localStorage nicht verfügbar ist
        }

        // Anzeige entsprechend des States setzen
        this._gridContainer.style.display = this._show ? 'grid' : 'none'

        // Die Columns bauen

        for ( let i = 1; i <= 27; i++ ) {
            let background = i % 2 === 0 ? 'bg-yellow-400' : 'transparent'
            if ( i === 1 || i === 27 ) {
                background = 'transparent'
            }

            const col = document.createElement('div')
            col.style.gridColumnStart = `${i}`
            col.style.gridColumnEnd = `${i + 1}`
            col.style.gridRowStart = '1'
            col.style.gridRowEnd = '2'
            col.style.height = '100%'
            col.style.margin = '0'
            col.classList.add(background)

            this._gridContainer.appendChild(col)
        }

        // Den Grid-Container im Body hinzufügen

        document.body.prepend(this._gridContainer)
    }

    disconnectedCallback() {
        super.disconnectedCallback()
        this._gridContainer?.remove() // Den Grid-Container wieder entfernen
    }


    render() 
    {
        return html`
            ${ 
                this._show
                ? html`<div @click=${() => this._toggleGridContainer(false)} class="p-3 bg-yellow-400/80 rounded-md cursor-pointer"><svg class="w-[18px] h-[18px] stroke-black" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m21 4c0-.478-.379-1-1-1h-16c-.62 0-1 .519-1 1v16c0 .621.52 1 1 1h16c.478 0 1-.379 1-1zm-9.75.5v15h-6.75v-15zm1.5 0h6.75v15h-6.75z" fill-rule="nonzero"/></svg></div>`
                : html`<div @click=${() => this._toggleGridContainer(true)} class="p-3 bg-yellow-400/20 rounded-md cursor-pointer"><svg class="w-[18px] h-[18px] stroke-black" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m21 4c0-.478-.379-1-1-1h-16c-.62 0-1 .519-1 1v16c0 .621.52 1 1 1h16c.478 0 1-.379 1-1zm-9.75.5v15h-6.75v-15zm1.5 0h6.75v15h-6.75z" fill-rule="nonzero"/></svg></div>`
            }
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'grid-indicator': GridIndicator
    }
}
